<template>
  <div>
    <div class="px-10 pt-10">
      <span class="text-h5 mb-3 font-weight-bold" style="display: block">
        {{ $t('SPACE.COPYWRITING.CHOOSE_THEME') }}
        <br />
      </span>
      <span class="text-descript mb-6" style="display: block">
        {{ $t('SPACE.COPYWRITING.SELECT_A_THEME_THAT_BEST_MATCHES_YOUR_WORK') }}
        <span style="color: #ff5084">
          {{ $t('SPACE.COPYWRITING.CANT_CHANGE') }}
        </span>
      </span>
      <Async :loading="loading">
        <v-tabs
          left
          hide-slider
          background-color="transparent"
          color=""
          v-model="currentTab"
          :ripple="false"
        >
          <v-tab>
            <span
              class="tab_item"
              :class="{ active: currentTab === currentTabStatus.BASIC }"
            >
              {{ $t('SETTING.WORD.BASIC_PLAN') }}
              <SizeBox width="11" />
              <div class="count_block b-rad-8 flex-center">
                ({{ freeExpo.length }})
              </div>
            </span>
          </v-tab>
          <v-tab>
            <span
              class="tab_item"
              :class="{ active: currentTab === currentTabStatus.CREATOR }"
            >
              {{ $t('PLAN.WORD.CREATOR_PLAN') }}
              <SizeBox width="11" />
              <div class="count_block b-rad-8 flex-center">
                ({{ creatorExpo.length }})
              </div>
            </span>
          </v-tab>
          <v-tab>
            <span
              class="tab_item"
              :class="{ active: currentTab === currentTabStatus.ADVANCED }"
            >
              {{ $t('PLAN.WORD.ADVANCE_PLAN') }}
              <SizeBox width="11" />
              <div class="count_block b-rad-8 flex-center">
                ({{ advanceExpo.length }})
              </div>
            </span>
          </v-tab>
          <v-tab>
            <span
              class="tab_item"
              :class="{ active: currentTab === currentTabStatus.CUSTOMIZE }"
            >
              {{ $t('COMMON.WORD.CUSTOMIZED') }}
              <SizeBox width="11" />
              <div class="count_block b-rad-8 flex-center">
                ({{ customizedFilterExpo.length }})
              </div>
            </span>
          </v-tab>
        </v-tabs>
        <SizeBox height="29" />
        <v-slide-y-transition group tag="div" class="row" leave-absolute>
          <v-col
            lg="4"
            md="6"
            sm="8"
            v-for="expo in showingExpos"
            :key="expo.alias"
          >
            <ThemeCard
              :expo-data="expo"
              :current-tab="currentTab"
              ref="ThemeCard"
            />
          </v-col>
          <v-col
            cols="8"
            :key="'init'"
            v-if="showingExpos.length == 0"
            style="
              position: relative;
              flex-direction: column;
              left: 50%;
              transform: translateX(-50%);
              padding-bottom: 40px;
            "
            class="d-flex align-center"
          >
            <div class="embed-container">
              <iframe
                src="https://www.youtube-nocookie.com/embed/qSdKSRFun80?rel=0"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <h3 style="font-size: 20px; margin: 30px 0">
              {{ $t('COMMON.COPYWRITING.CONTACT_VIRSODY_TO_CREATE') }}
            </h3>
            <v-btn
              depressed
              color="#fff"
              height="46"
              width="auto"
              class="w100p"
              :href="'https://docs.google.com/forms/d/e/1FAIpQLSdcxcP2VKi2I2oxQ6JLPnLBlg8zUTTaYslq00SuCRHqkHoekQ/viewform'"
              style="background-color: #00b6f0; font-size: 16px"
              :target="'_blank'"
            >
              {{ $t('COMMON.COPYWRITING.I_WANT_CUSTOMIZED_SPACE') }}
            </v-btn>
          </v-col>
        </v-slide-y-transition>
      </Async>
    </div>
  </div>
</template>
<script>
import { getCreateExhibitionScenes } from '@/api/panel';
import ThemeCard from '@/components/exhibitions/create/ThemeCard.vue';

const currentTabStatus = {
  BASIC: 0,
  CREATOR: 1,
  ADVANCED: 2,
  CUSTOMIZE: 3
};
export default {
  components: { ThemeCard },
  data: () => ({
    loading: false,
    currentTabStatus,
    currentTab: 0,
    allExpo: [],
    freeExpo: [],
    creatorExpo: [],
    advanceExpo: [],
    customizedExpo: [],
    customizedFilterExpo: []
  }),
  async created() {
    const payload = { lang: localStorage.getItem('language') };
    const res = await getCreateExhibitionScenes(payload);
    this.fetchData(res);
  },
  computed: {
    showingExpos() {
      switch (this.currentTab) {
        case currentTabStatus.ALL:
          return this.allExpo;
        case currentTabStatus.BASIC:
          return this.freeExpo;
        case currentTabStatus.CREATOR:
          return this.creatorExpo;
        case currentTabStatus.ADVANCED:
          return this.advanceExpo;
        case currentTabStatus.CUSTOMIZE: {
          return this.customizedFilterExpo;
        }
        default:
          return this.allExpo;
      }
    }
  },
  methods: {
    fetchData(theme) {
      theme.free.forEach((item, index) => {
        item.plan = '基礎';
        item.planKey = 'COMMON.WORD.BASIC';
      });
      theme.creator.forEach((item, index) => {
        item.plan = '創作者';
        item.planKey = 'COMMON.WORD.CREATOR';
      });
      theme.advance.forEach((item, index) => {
        item.plan = '進階';
        item.planKey = 'PLAN.WORD.ADVANCED';
      });
      theme.customized.forEach((item, index) => {
        item.plan = '訂製';
        item.planKey = 'COMMON.WORD.CUSTOMIZED';
      });
      this.allExpo = [
        ...theme.free,
        ...theme.creator,
        ...theme.advance,
        ...theme.customized
      ];
      this.freeExpo = theme.free;
      this.creatorExpo = theme.creator.map((expo) => {
        return {
          ...expo,
          cusHas: theme.customized.some((checkExpo) => {
            return expo.alias == checkExpo.alias;
          })
        };
      });
      this.advanceExpo = theme.advance.map((expo) => {
        return {
          ...expo,
          cusHas: theme.customized.some((checkExpo) => {
            return expo.alias == checkExpo.alias;
          })
        };
      });
      this.customizedExpo = theme.customized;
      let checkExpo = this.creatorExpo.concat(this.advanceExpo);
      this.customizedFilterExpo = this.customizedExpo.filter((expo) => {
        return checkExpo.every((checkExpo) => {
          return expo.alias != checkExpo.alias;
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  width: 100%;
  left: 0;
  top: 0;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
::v-deep {
  .v-slide-group__prev {
    display: none !important;
  }
  .v-tab {
    min-width: auto;
    padding: 0;
    margin-right: 30px;
    .v-ripple__container {
      display: none;
    }
    &:hover {
      &::before {
        opacity: 0 !important;
      }
      .tab_item {
        color: #fff;
        .count_block {
          color: #fff;
        }
        &::after {
          opacity: 1;
        }
      }
    }

    .tab_item {
      display: flex;
      align-items: center;
      position: relative;
      color: $neutral400;
      font-size: 16px;
      transition: ease 0.5s all;
      .count_block {
        transition: ease 0.5s all;
        width: 26px;
        height: 26px;
        // background-color: $menu2;
        color: $neutral400;
      }
      &::after {
        content: '';
        position: absolute;
        width: 17px;
        height: 3px;
        left: 50%;
        transform: translateX(-50%);
        bottom: -5px;
        background-color: $primary;
        opacity: 0;
        transition: ease 0.5s all;
      }
      &.active {
        color: #fff;
        .count_block {
          color: #fff;
        }
        &::after {
          opacity: 1;
        }
      }
    }
  }
}

.new_expo {
  border: 1px dashed #878787;
}
</style>